export const filterInfo = [
    {
      id: 0,
      name: 'All',
      key: 'all',
    },
    {
      id: 1,
      name: 'Pre-auth',
      key: 'pre-auth',
    },
    {
      id: 0,
      name: 'Over Serve',
      key: 'over-serve',
    },
    {
      id: 0,
      name: 'Id check',
      key: 'id-check',
    },
];